<script>
import FixableErrors from '@/components/service/FixableErrors.vue'

export default {
  components: {
    'mia-fixable-errors': FixableErrors
  }
}
</script>

<template>
  <mia-fixable-errors />
</template>
